class CcaSearchPrompts {
  constructor(root) {
    this.root = root;
    this.input = root.closest('form')?.querySelector('input[type="search"]');
    this.value = root.querySelector('span');
    this.prompts = root.dataset.searchPrompts.split('|').filter(Boolean);
    this.index = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!this.input || !this.value || this.prompts.length < 2) return;

    this.input.addEventListener('input', () => this.sync());
    this.input.addEventListener('focus', () => this.sync());
    this.input.addEventListener('blur', () => this.sync());
    document.addEventListener('visibilitychange', () => this.sync());
    this.sync();
  }

  sync() {
    const show = this.input.value.length === 0;
    this.root.hidden = !show;
    clearTimeout(this.timer);

    if (!show || this.reducedMotion || document.hidden) return;
    this.timer = setTimeout(() => this.next(), 3000);
  }

  next() {
    this.value.classList.add('is-changing');
    this.timer = setTimeout(() => {
      this.index = (this.index + 1) % this.prompts.length;
      this.value.textContent = this.prompts[this.index];
      this.value.classList.remove('is-changing');
      this.sync();
    }, 180);
  }
}

document.querySelectorAll('.cca-search-prompt').forEach((prompt) => new CcaSearchPrompts(prompt));

document.querySelectorAll('.header__search details').forEach((searchDetails) => {
  const syncSearchOverlayState = () => {
    document.documentElement.classList.toggle('cca-header-search-open', searchDetails.open);
  };

  searchDetails.addEventListener('toggle', syncSearchOverlayState);
  syncSearchOverlayState();
});
